import React, {Component} from "react";
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormGroup, Label, Input, Button} from "reactstrap";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import {validateField} from "../../../common/validation";
import MaskedInput from "react-text-mask";
import Alert from "react-s-alert";

class TelephoneModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disableSaveButton: false,
            isMounted : true,
            sorumluCepTel: null,
        };

        this.onChange = this.onChange.bind(this);
        this.saveClicked = this.saveClicked.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let sorumluCepTel = this.props.customerSorumluCepTel;
        this.setState({sorumluCepTel});
    }

    onChange(name, value) {
        let sorumluCepTel;
        sorumluCepTel = value;
        this.setState({sorumluCepTel});
    }

    saveClicked() {
        let self = this;
        self.setState({disableSaveButton: true});
        let error = self.validate();
        if (!error.valid) {
                Alert.error(error.message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            self.setState({disableSaveButton: false});
            return;
        } else {
            let data = new FormData();
            data.append("sorumluCepTel", self.state.sorumluCepTel);
            let params = {
                url: `/customer/saveChangedSorumluCepTel`,
                method: 'post',
                data
            };
            request(params)
                .then(response => {
                    self.props.toggle();
                }).catch(error => {
                self.setState({disableSaveButton: false});
                showAxiosError(error);
            });
        }
    }

    validate() {
        let sorumluCepTel = deepCopyObject(this.state.sorumluCepTel);
        let error = {valid: true, message: ""};
        if (typeof sorumluCepTel !== 'string' || !sorumluCepTel.trim()) {
            let error = { valid: false, message: "<b>Devam etmek için lütfen zorunlu alanları doldurunuz.</b>" };
            return error;
        }

        let phoneError = validateField("cellPhone", undefined, sorumluCepTel);
        if (!phoneError.valid) {
            error.valid = false;
            error.message += "<b>" + phoneError.message + "</b>";
        }

        return error;
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} size="lg">
                <ModalHeader
                    className="justify-content-center">
                    Sorumlu Cep Tel Bilgisi
                </ModalHeader>
                <ModalBody>
                    <div>
                        <Form>
                            <FormGroup row style={{textAlign: 'center'}}>
                                <Label sm={12} style={{fontWeight: 'bold', fontSize: '16px',
                                    color: "#f96332"}}>Sorumlu Cep Tel numarası +905xxxxxxxxx formatında olmalıdır. </Label>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="sorumluCepTel">Sorumlu Cep Tel: *</Label>
                                <Col sm={8}>
                                    <MaskedInput className="form-control"
                                                 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                                 placeholder="+90__________"
                                                 type="text"
                                                 name="sorumluCepTel"
                                                 value={this.state.sorumluCepTel}
                                                 onChange={(e) => this.onChange("sorumluCepTel", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <nav className="col-sm-12 row">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6"></div>
                        <div className="col-sm-3" style={{paddingLeft: "100px"}}>
                            <button position="rightSide"
                                    label="Kaydet"
                                    className="TekBtn kaydet"
                                    disabled={this.state.disableSaveButton}
                                    style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding:'9px 37px 9px 14px'}}
                                    onClick={this.saveClicked}> Kaydet</button>
                        </div>
                    </nav>
                </ModalFooter>
            </Modal>
        )
    }
}

export default TelephoneModal;
